// extracted by mini-css-extract-plugin
export default {"root":"GeneralForm_root__F7xYn","iconGroup":"GeneralForm_iconGroup__GPxRS","vmIcon":"GeneralForm_vmIcon__JFqwa","buttonWrapper":"GeneralForm_buttonWrapper__wT9b9"};